"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _core = _interopRequireDefault(require("../utils/core"));

var _jquery = _interopRequireDefault(require("../utils/jquery.webf"));

var _jquery2 = _interopRequireDefault(require("jquery"));

/**
 * options :
 *  - buttons
 *  - minScroll
 *  - position
 *
 * Méthodes publiques :
 */
(0, _jquery["default"])('stickybutton', {
  options: {
    buttons: [{
      label: 'Button 1',
      type: 'submit',
      "class": 'webf-button webf-button-primary',
      onClick: 'trigger'
    }],
    minScroll: 0,
    position: 'bottom'
  },
  _create: function _create() {
    this._draw();

    this._bindEvents();
  },
  _draw: function _draw() {
    var self = this;
    var buttons = this.option('buttons');
    var $stickyBar = (0, _jquery2["default"])('<div>').addClass('webf-stickybar');

    if (_core["default"].isDomElement(this.e[0])) {
      if (!this.e[0].tagName) {
        throw new Error('selector must be a form element');
      }
    }

    _core["default"].each(buttons, function (i, button) {
      var $button = (0, _jquery2["default"])('<button>').prop('type', button.type).text(button.label).addClass(['webf-sticky-button'].concat([button["class"]].join(' '))).on('click', function () {
        if (button.onClick == 'trigger') {
          return self.e.trigger('submit');
        }

        if (_core["default"].isFunction(button.onClick)) {
          self._call(button.onClick, $button[0]);
        }
      });
      $stickyBar.append($button);
    }, this);

    this.$stickyBar = $stickyBar;
    (0, _jquery2["default"])('body').append(this.$stickyBar);
  },
  _bindEvents: function _bindEvents() {
    var self = this;
    var minScroll = this.option('minScroll');
    (0, _jquery2["default"])(window).on('scroll webf.init-stickybar', function () {
      if (window.scrollY >= minScroll) {
        self.$stickyBar.addClass('visible');
      } else {
        self.$stickyBar.removeClass('visible');
      }
    }).trigger('webf-init-stickybar');
  },
  _destroy: function _destroy() {}
});